export default __webpack_public_path__ + "static/media/logo-bp-red.13642a32.svg";